<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">
          <i class="icon-trophy"></i>
          {{ $t('ranking.title') }} ({{ noOfStocks }})
        </h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Column -->
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <!-- Nav tabs -->
          <slot name="rankingNavigation" />
          <!-- Tab panes -->
          <div class="tab-content">
            <div class="tab-pane active" id="home" role="tabpanel">
              <div class="card-body padding-2 mt-2">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Column -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/Common/Breadcrumb";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import i18n from '../../../i18n';

export default {
  name: "RankingMain",
  components: {
    Breadcrumb,
    LoadingContainer
  },
  beforeMount() {
    this.getNoOfStocks();
  },
  computed: {
    ...mapGetters({
      item: "stock/item",
      form: "stock/form",
      defaultCode: "configuration/defaultCode",
      noOfStocks: "common/noOfStocks",
    }),
    currentPage() {
      return i18n.t(`pages.${this.$store.state.route.meta.title}`);
    },
  },
  methods: {
    ...mapActions({
      getStockInfo: "stock/getStockInfo",
      getNoOfStocks: "common/getNoOfStocks",
    }),
  }
};
</script>

<style scoped>

</style>
